import { render, staticRenderFns } from "./LabLocationPopup.vue?vue&type=template&id=0059b868&scoped=true&"
import script from "./LabLocationPopup.vue?vue&type=script&lang=js&"
export * from "./LabLocationPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0059b868",
  null
  
)

export default component.exports